

import pedalImage from "../../../static/images/TSDD/fx_view.webp"
import { Box, Typography, Grid } from "@mui/material";

const PostFX = () => {
  return <Box sx={{ p: 5, background: "#1a1a1a", justifyContent: "center", alignItems: "center" }} >

    <Grid container justifyContent={"center"} sx={{ background: "#1a1a1a" }}>
      <Grid item xs={12} md={10} justifyContent={"center"} sx={{ alignItems: "center", justifyContent: "center", display: "flex" }} >
        <img alt="Rack unit with multiple fx units" src={pedalImage} width="50%" style={{ maxWidth: "1400px" }} />
      </Grid>

    </Grid>
    <Box sx={{ width: "100%", justifyContent: "center" }}>
      <Typography variant="h3" sx={{ textAlign: "center", mb: 3 }}>Post Effects</Typography>
    </Box>
    <Grid container justifyContent={"center"} sx={{ background: "#1a1a1a", mb: 4 }}>
      <Grid item xs={12} md={6} lg={4}>
        <Typography variant="h6" sx={{ textAlign: "left" }}><b>Chorus:</b> Add depth to your sound with the chorus unit. Switch between two voicings: Tri-Chorus or Wide Chorus. The Tri-Chorus mode has three individual chorus voices panned L C R, creating a very rich sound. Wide mode uses two individual voices, panned left and right with the phase flipped for an extra wide chorus sound.</Typography>
        <br />
        <Typography variant="h6" sx={{ textAlign: "left" }}><b>Delay:</b> What's a lead tone without some of delay? This unit delivers a warm, organic echo that responds like a true analog unit, smoothly adapting to every timing change. Adjust the amount of warble with the modulation knob to fit your liking.</Typography>
        <br />
        <Typography variant="h6" sx={{ textAlign: "left" }}><b>Reverb:</b> Ambience is everything. This reverb moves effortlessly from intimate room reflections to vast, atmospheric spaces. Shape your tone with built-in high and low-end filters, and blend in just the right amount of wet signal. </Typography>
      </Grid>
    </Grid>

  </Box>
}

export default PostFX;